import router from '@/router'
import {getToken} from '@/utils/auth' // 验权

const whiteList = ['/index/login', '/index/register', '/index/forgetPassword','/index/loginPhone',] // 不重定向白名单

//
//放行路由
const whitegoods = [
    "/home", //首页
    "/category", //分类
    "/index/brand", //品牌制造
    "/index/brandList", //品牌制造详情
    "/goods/goodsList",
    "/goods/newGoods",
    "/goods/hotGoods",
    "/goods/newProductList"
]
const whiteListarr = whiteList.concat(whitegoods);
router.beforeEach((to, from, next) => {
    if(getToken()){    //获取到用户token
        next()
    }else {
        if(whiteListarr.indexOf(to.path) !== -1){
            next()
        }else {
            next('/index/login')
        }
    }
})
